import { motion } from "framer-motion";
import { FC, ReactNode } from "react";
import { useIntl } from "react-intl";
import { FaqItem } from "./FaqItem";

const FaqLayout: FC<{ children?: ReactNode }> = ({ children }) => {
  const intl = useIntl();

  return (
    <div className="relative flex min-h-screen overflow-x-hidden">
      <div className="relative hidden w-1/2 min-h-full md:flex">
        <img
          src="/image/landingPage/faq.png"
          className="hidden w-full min-h-full md:flex"
        />
        <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-30" />
      </div>

      <motion.div
        className="md:absolute bg-[#d0cece] bg-opacity-80 bottom-0 right-20 md:w-1/2 md:h-4/6 p-6 flex flex-col"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      >
        <div className="mb-4 text-2xl font-bold md:mb-8">
          {intl.formatMessage({ id: "faq.title" })}
        </div>
        <div className="flex flex-col flex-grow gap-4 overflow-auto md:gap-10">
          {children}
        </div>
      </motion.div>
    </div>
  );
};

export const FaqListing = () => {
  return (
    <div id="faq">
      <FaqLayout>
        <FaqItem index={1} />
        <FaqItem index={2} />
        <FaqItem index={3} />
        <FaqItem index={4} />
        <FaqItem index={5} />
        <FaqItem index={6} />
        <FaqItem index={7} />
        <FaqItem index={8} />
        <FaqItem index={9} />
        <FaqItem index={10} />
        <FaqItem index={11} />
        <FaqItem index={12} />
      </FaqLayout>
    </div>
  );
};
